const MESSAGE =
  "Une gestion centralisée de vos immeubles, biens, locataires, contrats, loyers, paiements, impayés, entretiens, dépenses et documents — dans un seul espace, avec des montants en FCFA.";

const GROUP_COPIES = 3;
const COPIES = Array.from({ length: GROUP_COPIES });

export default function AnnouncementBar() {
  return (
    <div
      className="announcement-marquee fixed top-0 inset-x-0 z-50 h-9 bg-primary-700 text-background-50"
      role="region"
      aria-label="Annonce"
    >
      <div className="announcement-marquee__track h-full">
        {[0, 1].map((group) => (
          <div
            key={group}
            className="announcement-marquee__group h-full"
            aria-hidden={group === 1 ? "true" : undefined}
          >
            {COPIES.map((_, index) => (
              <span
                key={index}
                className="flex items-center gap-3 px-6 text-xs md:text-sm font-label font-medium whitespace-nowrap"
              >
                <i className="ri-home-smile-2-line text-accent-300" aria-hidden="true" />
                {MESSAGE}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}